
import * as decorator from 'vue-property-decorator'
import config from '@/config';
import basePage from '@/views/BasePage'
import modelbase from '@/views/TModelBase'

export const Component = decorator.Component
export const Prop = decorator.Prop
export const Vue = decorator.Vue
export const Watch = decorator.Watch
export const Model = decorator.Model
export const Emit = decorator.Emit
export const Inject = decorator.Inject
export const Provide = decorator.Provide
export const Mixins = decorator.Mixins
export const Config = config
export const BasePage = basePage
export const TModelBase = modelbase
